import { Map as ImmutableMap } from 'immutable';

export function combineResourceActions(resources, actions) {
  return resources.map((resource) => ({
    resource,
    actions: Object.entries(actions[resource])
      .filter((entry) => entry[1])
      .map((entry) => entry[0])
  }));
}

export function splitResourceActions(resourceActions) {
  const mutableActions = ImmutableMap().asMutable();

  for (const resourceAction of resourceActions) {
    const resource = resourceAction.get('resource');
    for (const action of resourceAction.get('actions')) {
      mutableActions.setIn([resource, action], true);
    }
  }

  return {
    actions: mutableActions.asImmutable()
  };
}
